const SITES = new Map<string, Site>();

export interface IAuthDomain {
    companyAlias: string;
    facilityAlias: string;
}

export default class Site implements IAuthDomain {
    public static readonly GlobalAlias = '*';
    public static readonly Global: Site = Site.get();
    public static readonly System: Site = Site.get('system', 'system');

    private constructor(
        public readonly key: string,
        public readonly companyAlias: string,
        public readonly facilityAlias: string
    ) {}

    public toString() {
        return this.key;
    }

    private static createKey(companyAlias: string, facilityAlias: string) {
        return `${companyAlias}_${facilityAlias}`;
    }

    public static getFromKey(key: string): Site {
        const alias = key.split('_');
        return Site.get(alias[0], alias[1]);
    }

    public static get(companyAlias: string | null = null, facilityAlias: string | null = null): Site {
        companyAlias = companyAlias?.toLowerCase() ?? Site.GlobalAlias;
        facilityAlias = facilityAlias?.toLowerCase() ?? Site.GlobalAlias;

        const key = Site.createKey(companyAlias, facilityAlias);

        let site = SITES.get(key);
        if (!site) {
            SITES.set(key, (site = new Site(key, companyAlias, facilityAlias)));
        }

        return site;
    }

    public compareTo(other: Site) {
        if (!other) return -1;

        const companyAliasResult = Site.compareAlias(this.companyAlias, other.companyAlias);

        return companyAliasResult === 0
            ? Site.compareAlias(this.facilityAlias, other.facilityAlias)
            : companyAliasResult;
    }

    private static compareAlias(left: string, right: string) {
        if (left === right) return 0;

        if (left === Site.GlobalAlias) return -1;
        if (right === Site.GlobalAlias) return 1;
        return left.localeCompare(right);
    }
}
